import { Button, type ButtonProps, CircularProgress } from '@mui/material';
import type { FC, ReactNode } from 'react';

interface LoadingButtonProps extends ButtonProps {
  loading: boolean;
  children: ReactNode;
}

export const LoadingButton: FC<LoadingButtonProps> = ({ loading, children, ...props }) => {
  return (
    <Button {...props} startIcon={loading ? <CircularProgress size={20} /> : null} disabled={loading || props.disabled}>
      {children}
    </Button>
  );
};
